import { Control, UseFormSetValue, useWatch } from 'react-hook-form';
import { CreateRecyclingConsignmentOrderV2SchemaType } from '../../common';
import { FormLabel } from '../../form-label';
import i18n from 'i18n';
import LOCALS from 'commons/locals';
import {
  generateRankDesc,
  LANG_LIST,
  RAND_DESC_OPTION_LIST,
} from 'pages/product/create-page-v2/common';
import { Controller } from 'react-hook-form';
import { Input, Tag } from 'antd';
import classNames from 'classnames';
import { useAppSelector } from 'store/hooks';
import { selectGlobalInfo } from 'store/slices/globalInfoSlice';

const RankDesc = ({
  control,
  index,
  setValue,
}: {
  control: Control<CreateRecyclingConsignmentOrderV2SchemaType>;
  index: number;
  setValue: UseFormSetValue<CreateRecyclingConsignmentOrderV2SchemaType>;
}) => {
  const { language, rankSelectOptions } = useAppSelector(selectGlobalInfo);
  const rank = useWatch({ control, name: `productList.${index}.rank` });

  return (
    <div className="flex gap-2">
      <FormLabel required>{i18n.t(LOCALS.rank_desc)}:</FormLabel>

      <div className="relative w-full">
        <div className="items-center w-full grid grid-cols-1 gap-y-3 bg-gray-200 p-3 rounded-md">
          {LANG_LIST.map((lang) => {
            return (
              <div key={lang} className="flex gap-1 flex-col">
                <Controller
                  name={`productList.${index}.rankDesc.${lang}`}
                  control={control}
                  render={({ field }) => {
                    return (
                      <div className="flex gap-1 w-full">
                        <Tag
                          color={lang === language ? '#1677ff' : 'default'}
                          className={classNames(
                            'flex items-center justify-center mx-0 shrink-0',
                            language === 'en' ? 'w-40' : 'w-[120px]'
                          )}
                        >
                          {i18n.t(lang)}
                        </Tag>
                        <Input.TextArea
                          {...field}
                          autoSize={true}
                          className={classNames(
                            language === lang ? 'border-[#1677ff] border-2' : ''
                          )}
                          placeholder={i18n.t(LOCALS.please_enter) || ''}
                        />
                      </div>
                    );
                  }}
                ></Controller>

                {/* 只显示在对应语言下 */}
                {language === lang && (
                  <Controller
                    name={`productList.${index}.selectedRankDescOptions`}
                    control={control}
                    render={({ field }) => {
                      return (
                        <div className="flex gap-4 w-full flex-col">
                          {RAND_DESC_OPTION_LIST.map((item) => {
                            return (
                              <div key={item.key} className="flex gap-2 w-full">
                                <div
                                  className={classNames(
                                    'text-right shrink-0',
                                    language === 'ja' ? 'w-40' : 'w-[120px]'
                                  )}
                                >
                                  <span className="font-medium">
                                    {item.title}:
                                  </span>
                                </div>

                                <div className="flex gap-1 flex-wrap">
                                  {item.options.map((option, index2) => {
                                    const isChecked =
                                      field.value[item.key].includes(index2);

                                    return (
                                      <Tag
                                        key={index2}
                                        className={classNames(
                                          'cursor-pointer text-sm mx-0 border border-black',
                                          isChecked
                                            ? 'bg-blue-500 text-white'
                                            : 'hover:border-blue-500 hover:text-blue-500'
                                        )}
                                        onClick={() => {
                                          if (isChecked) {
                                            const newSelectState = {
                                              ...field.value,
                                              [item.key]: field.value[
                                                item.key
                                              ].filter((id) => id !== index2),
                                            };
                                            field.onChange(newSelectState);
                                            setValue(
                                              `productList.${index}.rankDesc`,
                                              generateRankDesc({
                                                selectedRankDescOptions:
                                                  newSelectState,
                                                rank,
                                                rankSelectOptions,
                                              })
                                            );
                                          } else {
                                            const newSelectState = {
                                              ...field.value,
                                              [item.key]: [
                                                ...field.value[item.key],
                                                index2,
                                              ],
                                            };
                                            field.onChange(newSelectState);
                                            setValue(
                                              `productList.${index}.rankDesc`,
                                              generateRankDesc({
                                                selectedRankDescOptions:
                                                  newSelectState,
                                                rank,
                                                rankSelectOptions,
                                              })
                                            );
                                          }
                                        }}
                                      >
                                        {option.name}
                                      </Tag>
                                    );
                                  })}
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      );
                    }}
                  ></Controller>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default RankDesc;
